/**
 * ActivityProfile — UML Activity / Interaction Overview diagrams.
 * See plans/software-design/domain.md § 6.
 */

import type { DomainDataProfile } from '../../../core/data-profiles';
import type { DiagramType } from '../../../lib/diagram/registries';

export type ActivityNodeType = 'act_action' | 'act_decision' | 'act_fork_join' | 'act_initial' | 'act_final' | 'act_signal' | 'act_swimlane';
export type ActivityEdgeType = 'act_flow' | 'act_object_flow';

export const ActivityProfile: DomainDataProfile<ActivityNodeType, ActivityEdgeType> = {
  domainId: 'activity',
  profileVersion: '1.0',
  diagramTypes: ['uml' as DiagramType],
  nodeTypes: ['act_action', 'act_decision', 'act_fork_join', 'act_initial', 'act_final', 'act_signal', 'act_swimlane'],
  edgeTypes: ['act_flow', 'act_object_flow'],
  vocabulary: {
    recordSingular: 'Action',
    recordPlural: 'Actions',
    repositoryLabel: 'Activity',
    hierarchyLabel: 'Flow',
    importAction: 'Import Activity',
    keyColumnHint: 'Action',
    commitLabel: 'Push Activity',
    pullLabel: 'Refresh Activity',
    diagramLabel: 'activity diagram',
  },
  fieldAliases: {
    name: ['action', 'actionName'],
  },
  requiredProps: ['name'],
  recommendedProps: [],
  primaryShapeType: 'act_action',
  propsToAttrsMapping: {
    name: 'name',
    swimlane: 'swimlane',
  },
  relationshipPackId: 'software-design-relationships',
};
